// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-family: 'Maven Pro', sans-serif;
    font-size: 15px;
    overflow-x: hidden;
    scroll-behavior: smooth;
}
.error {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
}

.no-found {
    text-align: center;
    padding: 3rem 0;
}

.no-found img {
    height: 200px;
}

.no-found p {
    font-size: 20px;
    font-weight: 600;
    margin-top: 2rem;
    margin-bottom: 0;
}

.Image-Map {
    width: 40px;
    height: 40px;
}

.no-found-page {
    text-align: center;
}

.no-found-page img {
    height: 300px;
    margin-bottom: 3rem;
}

.no-found-page h1 {
    font-weight: 600;
}

.no-found-page p {
    font-size: 20px;
    color: var(--gray);
    margin-bottom: 1.5rem;
}

/* ComingSoon */
.coming-soon-wrapper {
  height: 100vh;
  background: url('https://source.unsplash.com/1600x900/?technology,abstract') no-repeat center center;
  background-size: cover;
  position: relative;
  overflow: hidden;
}

.coming-soon-wrapper .overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1;
}

.coming-soon-wrapper .content {
  position: relative;
  z-index: 2;
}`, "",{"version":3,"sources":["webpack://./src/style/App.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,eAAe;IACf,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,oGAAoG;EACpG,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ","sourcesContent":["body {\n    font-family: 'Maven Pro', sans-serif;\n    font-size: 15px;\n    overflow-x: hidden;\n    scroll-behavior: smooth;\n}\n.error {\n    height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.no-found {\n    text-align: center;\n    padding: 3rem 0;\n}\n\n.no-found img {\n    height: 200px;\n}\n\n.no-found p {\n    font-size: 20px;\n    font-weight: 600;\n    margin-top: 2rem;\n    margin-bottom: 0;\n}\n\n.Image-Map {\n    width: 40px;\n    height: 40px;\n}\n\n.no-found-page {\n    text-align: center;\n}\n\n.no-found-page img {\n    height: 300px;\n    margin-bottom: 3rem;\n}\n\n.no-found-page h1 {\n    font-weight: 600;\n}\n\n.no-found-page p {\n    font-size: 20px;\n    color: var(--gray);\n    margin-bottom: 1.5rem;\n}\n\n/* ComingSoon */\n.coming-soon-wrapper {\n  height: 100vh;\n  background: url('https://source.unsplash.com/1600x900/?technology,abstract') no-repeat center center;\n  background-size: cover;\n  position: relative;\n  overflow: hidden;\n}\n\n.coming-soon-wrapper .overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.7);\n  z-index: 1;\n}\n\n.coming-soon-wrapper .content {\n  position: relative;\n  z-index: 2;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
